import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthState } from '../models/auth-state';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectDsToken = createSelector(selectAuthState, (state: AuthState) => state.dsToken);
export const selectAccessToken = createSelector(selectAuthState, (state: AuthState) => state.accessToken);
export const selectRefreshToken = createSelector(selectAuthState, (state: AuthState) => state.refreshToken);
export const selectReloginUrl = createSelector(selectAuthState, (state: AuthState) => state.reloginUrl);
